import { useQuery } from '@tanstack/react-query'
import { SlidersHorizontal } from 'lucide-react'
import { accountsApi } from '../api/client'
import { relativeTime } from '../lib/relativeTime'
import './OverlayCard.css'

interface OverlayCardProps {
  accountId: number
}

export function OverlayCard({ accountId }: OverlayCardProps) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['overlay', accountId],
    queryFn: () => accountsApi.overlay(accountId),
    retry: 1,
    refetchInterval: 60000,
  })

  const entries = Object.entries(data?.overlay ?? {})

  return (
    <div className="card overlay-card">
      <div className="card-header">
        <h3 className="card-title">
          <SlidersHorizontal size={18} className="icon" aria-hidden="true" />
          Config overlay
        </h3>
        {data && <span className="caption">v<span className="num">{data.version}</span></span>}
      </div>

      {isLoading ? (
        <div className="loading"><div className="spinner" /></div>
      ) : isError ? (
        <div className="empty-state">
          <div className="empty-icon"><SlidersHorizontal size={28} aria-hidden="true" /></div>
          <div className="empty-text">overlay unavailable</div>
        </div>
      ) : entries.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon"><SlidersHorizontal size={28} aria-hidden="true" /></div>
          <div className="empty-text">no overlay — running base config</div>
        </div>
      ) : (
        <ul className="overlay-card-list mono">
          {entries.map(([key, value]) => (
            <li key={key} className="overlay-card-row">
              <span className="overlay-card-key">{key}</span>
              <span className="overlay-card-value">{JSON.stringify(value)}</span>
            </li>
          ))}
        </ul>
      )}

      <div className="overlay-card-footer">
        <span>updated {relativeTime(data?.updated_at)}</span>
        <span className="caption">overlay changes activate next cycle</span>
      </div>
    </div>
  )
}
